import { useNavigate } from 'react-router-dom';

const PreviousAndNextButton = ({
  prevIndex,
  nextIndex,
  illustrations,
  currentIndex,
}) => {
  const navigate = useNavigate();
  const isLastIllustration = currentIndex >= illustrations.length - 1;
  const isFirstIllustration = currentIndex <= 0

  return (
    <div className="flex items-center justify-center mt-4 lg:w-4/5 mx-auto font-nunito">
      <button
        className={`px-4 py-2 ${currentIndex <= 0 ? 'text-gray-500' : 'text-black'
          }`}
        onClick={() =>
          navigate(`/illustrations/${illustrations[prevIndex]._id}`, { viewTransition: true })
        }
        disabled={isFirstIllustration}
      >
        Prev
      </button>
      <span>/</span>
      <button
        className={`px-4 py-2 ${currentIndex >= illustrations.length - 1
          ? 'text-gray-500'
          : 'text-black'
          }`}
        onClick={() =>
          navigate(`/illustrations/${illustrations[nextIndex]._id}`, { viewTransition: true })
        }
        disabled={isLastIllustration}
      >
        Next
      </button>
    </div>
  );
};

export default PreviousAndNextButton;
